<div class="date-picker-container">
    <div
        class="date-picker-container-left"
        [class.disabled]="previousIsDisabled"
        (click)="previousDate()"
    >
        <div class="date-picker-container-left-icon">
            <i class="fa-solid fa-backward-step" [ngStyle]="{'color': color}"></i>
        </div>
    </div>
    <div
        class="date-picker-container-center"
        [class.disabled]="disabled"
        (click)="openDialog()"
    >
        <div class="date-picker-container-center-top" [ngStyle]="{'background-color': color}">
            <div class="date-picker-container-center-top-month">{{monthName}}</div>
        </div>
        <div class="date-picker-container-center-bottom">
            <div class="date-picker-container-center-bottom-day" [ngStyle]="{'color': color}">{{day}}</div>
        </div>
    </div>
    <div
        class="date-picker-container-right"
        [class.disabled]="nextIsDisabled"
        (click)="nextDate()"
    >
        <div class="date-picker-container-right-icon">
            <i class="fa-solid fa-forward-step" [ngStyle]="{'color': color}"></i>
        </div>
    </div>
</div>
